import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import userService from '../../../services/user.service';

const initialState = {
  isCreatingUser: false,
  isEdittingUser: false,
  isCreatingRole: false,
  isEditingRole: false,
  listUser: [],
  listUserSearch: [],
  loading: false,
  error: null,
  userDetail: {},
  loadingDetail: false,
  isSelectedProduct: true,
  listWorkplace: [],
  listUserRoleInternal: [],
  listUserRoleBank: [],
  listProductType: [],
};

export const getListUser = createAsyncThunk('user/list', async (payload) => {
  const response = userService.getListUser(payload);
  return response;
});

export const getListUserSearch = createAsyncThunk('user/list/search', async (payload) => {
  const response = userService.getListUser(payload);
  return response;
});

export const getUserDetail = createAsyncThunk('user/detail', async (payload) => {
  const response = await userService.getUserDetail(payload);
  return response;
});

export const createUser = createAsyncThunk('user/create', async (payload, { rejectWithValue }) => {
  try {
    const response = await userService.createUser(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateUser = createAsyncThunk('user/update', async (payload, { rejectWithValue }) => {
  try {
    const response = await userService.updateUser(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getListWorkplace = createAsyncThunk('user/workplace', async (payload) => {
  const response = await userService.getListWorkplace(payload);
  return response;
});

export const getListUserRoleInternal = createAsyncThunk(
  'user/userrole/internal',
  async (payload) => {
    const response = await userService.getListUserRole(payload);
    return response;
  },
);

export const getListUserRoleBank = createAsyncThunk('user/userrole/bank', async (payload) => {
  const response = await userService.getListUserRole(payload);
  return response;
});

export const getListProductType = createAsyncThunk('user/producttype', async (payload) => {
  const response = await userService.getListProductType(payload);
  return response;
});

const userManagementSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserDetail(state, action) {
      state.userDetail = action.payload;
    },
    setListUserSearch(state, action) {
      state.listUserSearch = action.payload;
    },
    setListUser(state, action) {
      state.listUser = action.payload;
    },
    setIsCreatingUser(state, action) {
      state.isCreatingUser = action.payload;
    },
    setIsEdittingUser(state, action) {
      state.isEdittingUser = action.payload;
    },
    setIsSelectedProduct(state, action) {
      state.isSelectedProduct = action.payload;
    },
    setIsCreatingRole(state, action) {
      state.isCreatingRole = action.payload;
    },
    setIsEditingRole(state, action) {
      state.isEditingRole = action.payload;
    },
    cleanUpState(state) {
      state.isCreatingUser = initialState.isCreatingUser;
      state.isEdittingUser = initialState.isEdittingUser;
      state.isCreatingRole = initialState.isCreatingRole;
      state.listUser = initialState.listUser;
      state.listUserSearch = initialState.listUserSearch;
      state.loading = initialState.loading;
      state.error = initialState.error;
      state.userDetail = initialState.userDetail;
      state.loadingDetail = initialState.loadingDetail;
      state.isSelectedProduct = initialState.isSelectedProduct;
      state.listWorkplace = initialState.listWorkplace;
      state.listUserRoleInternal = initialState.listUserRoleInternal;
      state.listUserRoleBank = initialState.listUserRoleBank;
      state.listProductType = initialState.listProductType;
    },
  },
  extraReducers: (builder) => {
    // list user
    // builder.addCase(getListUser.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(getListUser.fulfilled, (state, action) => {
    //   state.listUser = action.payload.data;
    //   state.loading = false;
    //   state.error = null;
    // });
    // builder.addCase(getListUser.rejected, (state, action) => {
    //   state.error = action.payload;
    //   state.loading = false;
    // });
    // get list user search
    // builder.addCase(getListUserSearch.fulfilled, (state, action) => {
    //   state.listUserSearch = action.payload.data.data;
    // });
    // user detail
    builder.addCase(getUserDetail.pending, (state) => {
      state.loadingDetail = true;
    });
    builder.addCase(getUserDetail.fulfilled, (state, action) => {
      state.userDetail = action.payload.data;
      state.loadingDetail = false;
      state.error = null;
    });
    builder.addCase(getUserDetail.rejected, (state, action) => {
      state.error = action.payload;
      state.loadingDetail = false;
    });
    // create user
    // builder.addCase(createUser.pending, (state) => {
    //   // debug-console.log(state);
    // });
    builder.addCase(createUser.fulfilled, (state) => {
      state.error = null;
    });
    builder.addCase(createUser.rejected, (state, action) => {
      state.error = action.payload;
    });
    // update user
    // builder.addCase(updateUser.pending, (state) => {
    //   // debug-console.log(state);
    // });
    builder.addCase(updateUser.fulfilled, (state, action) => {
      if (action.payload.status === 200 || action.payload.status === 204) {
        state.isCreatingUser = false;
        state.isEdittingUser = false;
        state.error = null;
      }
    });
    builder.addCase(updateUser.rejected, (state, action) => {
      state.error = action.payload;
    });
    // get list workplace
    builder.addCase(getListWorkplace.fulfilled, (state, action) => {
      state.listWorkplace = action.payload.data;
      state.error = null;
    });
    builder.addCase(getListWorkplace.rejected, (state, action) => {
      state.error = action.payload;
    });
    // get list user role internal
    builder.addCase(getListUserRoleInternal.fulfilled, (state, action) => {
      state.listUserRoleInternal = action.payload.data;
      state.error = null;
    });
    builder.addCase(getListUserRoleInternal.rejected, (state, action) => {
      state.error = action.payload;
    });
    // get list user role bank
    builder.addCase(getListUserRoleBank.fulfilled, (state, action) => {
      state.listUserRoleBank = action.payload.data;
      state.error = null;
    });
    builder.addCase(getListUserRoleBank.rejected, (state, action) => {
      state.error = action.payload;
    });
    // get list product type
    builder.addCase(getListProductType.fulfilled, (state, action) => {
      state.listProductType = action.payload.data.productTypes;
      state.error = null;
    });
    builder.addCase(getListProductType.rejected, (state, action) => {
      state.error = action.payload;
    });
  },
});

export const {
  setUserDetail,
  setListUser,
  setListUserSearch,
  setIsCreatingUser,
  setIsEdittingUser,
  setIsCreatingRole,
  setIsEditingRole,
  cleanUpState,
  setIsSelectedProduct,
} = userManagementSlice.actions;
export default userManagementSlice.reducer;
